var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-content main-menu" },
      [
        _vm.isAdmin === "true"
          ? _c(
              "router-link",
              { attrs: { to: { name: "process-user-register" } } },
              [
                _c("a", { staticClass: "menu-item" }, [
                  _c("i", { staticClass: "menu-icon fa fa-share-alt" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "menu-name" }, [
                    _vm._v("ユーザー一括登録")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "menu-desc" }, [
                    _vm._v(
                      "ユーザーに一括で個人コード・ゲートグループの登録を行います。"
                    )
                  ])
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdmin === "true"
          ? _c("router-link", { attrs: { to: { name: "user" } } }, [
              _c("a", { staticClass: "menu-item" }, [
                _c("i", { staticClass: "menu-icon fa fa-user" }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-name" }, [_vm._v("ユーザー")]),
                _vm._v(" "),
                _c("span", { staticClass: "menu-desc" }, [
                  _vm._v("ユーザーの登録・編集"),
                  _c("br"),
                  _vm._v("を行います。")
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdmin === "true"
          ? _c("router-link", { attrs: { to: { name: "gates" } } }, [
              _c("a", { staticClass: "menu-item" }, [
                _c("i", {
                  staticClass: "menu-icon glyphicon glyphicon-log-in"
                }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-name" }, [_vm._v("ゲート")]),
                _vm._v(" "),
                _c("span", { staticClass: "menu-desc" }, [
                  _vm._v("ゲートの登録・編集"),
                  _c("br"),
                  _vm._v("を行います。")
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdmin === "true"
          ? _c("router-link", { attrs: { to: { name: "group" } } }, [
              _c("a", { staticClass: "menu-item" }, [
                _c("i", { staticClass: "menu-icon fa fa-users" }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-name" }, [
                  _vm._v("ゲートグループ")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "menu-desc" }, [
                  _vm._v("ゲートグループの登録・編集"),
                  _c("br"),
                  _vm._v("を行います。")
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdmin === "true"
          ? _c("router-link", { attrs: { to: { name: "pcode" } } }, [
              _c("a", { staticClass: "menu-item" }, [
                _c("i", { staticClass: "menu-icon fa fa-credit-card " }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-name" }, [
                  _vm._v("個人コード")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "menu-desc" }, [
                  _vm._v("NFCカードとテンキー情報の登録・編集を行います。")
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdmin === "true"
          ? _c("router-link", { attrs: { to: { name: "phones" } } }, [
              _c("a", { staticClass: "menu-item" }, [
                _c("i", { staticClass: "menu-icon glyphicon glyphicon-phone" }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-name" }, [
                  _vm._v("スマートフォン")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "menu-desc" }, [
                  _vm._v("スマートフォンの登録・編集"),
                  _c("br"),
                  _vm._v("を行います。")
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("router-link", { attrs: { to: { name: "logs" } } }, [
          _c("a", { staticClass: "menu-item" }, [
            _c("i", { staticClass: "menu-icon glyphicon glyphicon-list" }),
            _vm._v(" "),
            _c("span", { staticClass: "menu-name" }, [_vm._v("ログ情報")]),
            _vm._v(" "),
            _c("span", { staticClass: "menu-desc" }, [
              _vm._v("ログ情報の閲覧・CSV出力"),
              _c("br"),
              _vm._v("を行います。")
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.isAdmin === "true"
          ? _c("router-link", { attrs: { to: { name: "setting" } } }, [
              _c("a", { staticClass: "menu-item" }, [
                _c("i", { staticClass: "menu-icon glyphicon glyphicon-cog" }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-name" }, [
                  _vm._v("システム設定")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "menu-desc" }, [
                  _vm._v("各種情報の設定・編集"),
                  _c("br"),
                  _vm._v("を行います。")
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdmin === "true"
          ? _c("router-link", { attrs: { to: { name: "keyadd" } } }, [
              _c("a", { staticClass: "menu-item" }, [
                _c("i", {
                  staticClass: "menu-icon glyphicon glyphicon-check menu-icon"
                }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-name" }, [_vm._v("鍵共有")]),
                _vm._v(" "),
                _c("span", { staticClass: "menu-desc" }, [
                  _vm._v("ユーザーに対して一時的な権限付与を行います。")
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isAdmin === "true"
          ? _c("router-link", { attrs: { to: { name: "export" } } }, [
              _c("a", { staticClass: "menu-item" }, [
                _c("i", { staticClass: "menu-icon fa fa-share" }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-name" }, [
                  _vm._v("CSVエクスポート")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "menu-desc" }, [
                  _vm._v("各種項目のCSVファイルへのエクスポートを行います。")
                ])
              ])
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "breadcrumbs ace-save-state",
        attrs: { id: "breadcrumbs" }
      },
      [
        _c("ul", { staticClass: "breadcrumb" }, [
          _c("li", [
            _c("a", { attrs: { href: "#" } }, [_vm._v("メインメニュー")])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f042b266", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f042b266","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/Index.vue
// module id = null
// module chunks = 